export const bestProducts = [
  {
    id: 1,
    name: "약손콩이 200mlX2병",
    category: "yaksonkong",
    weight: "2병 세트",
    price: 50000,
    usdtPrice: 32,
    originalPrice: 60000,
    discount: 17,
    rating: 4.9,
    reviews: 214,
    image: "https://storage.readdy-site.link/project_files/fab39877-057d-4165-9475-a35374cb4014/e638276f-9e94-4716-bc0b-c598f1919967_YAKSONKONGE_11.jpg?v=2b745acb2616ef0d1c374f92935c8f51",
    badge: "인기",
    description: "국내산 약손콩을 담은 프리미엄 2병 세트입니다. 가족과 함께 건강을 챙기기에 딱 좋은 구성입니다.",
    stock: 60,
  },
  {
    id: 2,
    name: "약손콩이 200mlX5병",
    category: "yaksonkong",
    weight: "5병 세트",
    price: 100000,
    usdtPrice: 65,
    originalPrice: 130000,
    discount: 23,
    rating: 4.9,
    reviews: 178,
    image: "https://storage.readdy-site.link/project_files/fab39877-057d-4165-9475-a35374cb4014/e638276f-9e94-4716-bc0b-c598f1919967_YAKSONKONGE_11.jpg?v=2b745acb2616ef0d1c374f92935c8f51",
    badge: "베스트",
    description: "알뜰하게 구성된 약손콩이 5병 세트입니다. 가족 모두가 함께 꾸준히 섭취하기에 최적의 경제적인 선택입니다.",
    stock: 45,
  },
  {
    id: 3,
    name: "스피루리나 200mgX3,600정 1BOX",
    category: "spirulina",
    weight: "200mgX3,600정 1BOX",
    price: 250000,
    usdtPrice: 160,
    originalPrice: 320000,
    discount: 22,
    rating: 4.8,
    reviews: 312,
    image: "https://storage.readdy-site.link/project_files/fab39877-057d-4165-9475-a35374cb4014/39229809-5b7c-4182-a3dc-611e808ad51d___1_1.jpg?v=22f7d1d2f402b06ac30da9e380ca1fa7",
    badge: "대용량",
    description: "장기 복용에 최적화된 스피루리나 대용량 BOX입니다. 3,600정으로 온 가족의 면역력 관리를 책임집니다.",
    stock: 30,
  },
];

export const allProducts = [
  ...bestProducts,
  {
    id: 5,
    name: "스피루리나 캡슐",
    category: "spirulina",
    weight: "300캡슐 (180g)",
    price: 35000,
    originalPrice: 45000,
    discount: 22,
    rating: 4.7,
    reviews: 142,
    image:
      "https://public.readdy.ai/ai/img_res/b8dbc2b55de9142d7ab79b2693f54d30.jpg",
    badge: "",
    description: "캡슐 형태로 더욱 간편하게 섭취할 수 있는 스피루리나입니다. 맛과 향이 부담스러운 분들께 추천합니다.",
    stock: 70,
  },
  {
    id: 6,
    name: "스피루리나 스틱",
    category: "spirulina",
    weight: "30포 (90g)",
    price: 29000,
    originalPrice: 36000,
    discount: 19,
    rating: 4.6,
    reviews: 98,
    image:
      "https://readdy.ai/api/search-image?query=spirulina%20powder%20stick%20packets%20in%20elegant%20box%20packaging%20on%20clean%20white%20marble%20surface%20with%20soft%20natural%20lighting%20minimalist%20product%20photography%20portable%20health%20supplement&width=400&height=400&seq=6&orientation=squarish",
    badge: "",
    description: "1회 분량씩 개별 포장된 스틱 타입 스피루리나입니다. 휴대와 섭취가 매우 편리합니다.",
    stock: 55,
  },
  {
    id: 7,
    name: "약손콩 두유 분말",
    category: "yaksonkong",
    weight: "400g",
    price: 26000,
    originalPrice: 33000,
    discount: 21,
    rating: 4.8,
    reviews: 203,
    image:
      "https://readdy.ai/api/search-image?query=premium%20soybean%20milk%20powder%20in%20elegant%20white%20pouch%20bag%20on%20clean%20white%20marble%20surface%20with%20soft%20natural%20lighting%20minimalist%20product%20photography%20organic%20health%20food%20beverage&width=400&height=400&seq=7&orientation=squarish",
    badge: "신제품",
    description: "물에 타서 바로 마실 수 있는 두유 분말입니다. 고소하고 부드러운 맛이 일품입니다.",
    stock: 90,
  },
  {
    id: 8,
    name: "약손콩 선식",
    category: "yaksonkong",
    weight: "500g",
    price: 32000,
    originalPrice: 40000,
    discount: 20,
    rating: 4.9,
    reviews: 267,
    image:
      "https://readdy.ai/api/search-image?query=traditional%20korean%20mixed%20grain%20powder%20in%20premium%20kraft%20pouch%20bag%20on%20clean%20white%20marble%20surface%20with%20soft%20natural%20lighting%20minimalist%20product%20photography%20healthy%20breakfast%20meal&width=400&height=400&seq=8&orientation=squarish",
    badge: "베스트",
    description: "약손콩과 각종 곡물을 배합한 영양 만점 선식입니다. 한 끼 식사 대용으로 완벽합니다.",
    stock: 40,
  },
  {
    id: 9,
    name: "스피루리나 파우더 대용량",
    category: "spirulina",
    weight: "500g",
    price: 78000,
    originalPrice: 98000,
    discount: 20,
    rating: 4.9,
    reviews: 156,
    image:
      "https://readdy.ai/api/search-image?query=large%20size%20spirulina%20green%20powder%20in%20elegant%20glass%20jar%20on%20clean%20white%20marble%20surface%20with%20soft%20natural%20lighting%20minimalist%20product%20photography%20organic%20superfood%20health%20supplement%20bulk%20size&width=400&height=400&seq=9&orientation=squarish",
    badge: "가성비",
    description: "가족 모두가 함께 먹기 좋은 대용량 스피루리나 파우더입니다. 경제적이고 실속 있는 선택입니다.",
    stock: 35,
  },
  {
    id: 10,
    name: "약손콩 로스팅",
    category: "yaksonkong",
    weight: "200g",
    price: 18000,
    originalPrice: 23000,
    discount: 22,
    rating: 4.6,
    reviews: 124,
    image:
      "https://readdy.ai/api/search-image?query=roasted%20soybeans%20in%20elegant%20kraft%20paper%20pouch%20bag%20on%20clean%20white%20marble%20surface%20with%20soft%20natural%20lighting%20minimalist%20product%20photography%20healthy%20snack%20organic%20food&width=400&height=400&seq=10&orientation=squarish",
    badge: "",
    description: "고소하게 볶은 약손콩입니다. 간식으로도 좋고, 샐러드나 요리에 토핑으로 활용하기 좋습니다.",
    stock: 65,
  },
  {
    id: 11,
    name: "스피루리나 정제 대용량",
    category: "spirulina",
    weight: "1000정 (500g)",
    price: 58000,
    originalPrice: 75000,
    discount: 23,
    rating: 4.8,
    reviews: 189,
    image:
      "https://readdy.ai/api/search-image?query=large%20bottle%20spirulina%20tablets%20pills%20in%20modern%20white%20container%20on%20clean%20white%20marble%20surface%20with%20soft%20natural%20lighting%20minimalist%20product%20photography%20health%20supplement%20bulk%20size&width=400&height=400&seq=11&orientation=squarish",
    badge: "가성비",
    description: "장기 복용에 적합한 대용량 스피루리나 정제입니다. 꾸준한 건강 관리를 원하시는 분께 추천합니다.",
    stock: 48,
  },
  {
    id: 12,
    name: "약손콩 환 선물세트",
    category: "yaksonkong",
    weight: "250g x 3개",
    price: 68000,
    originalPrice: 85000,
    discount: 20,
    rating: 4.9,
    reviews: 95,
    image:
      "https://readdy.ai/api/search-image?query=premium%20korean%20soybean%20pills%20gift%20set%20in%20elegant%20box%20packaging%20on%20clean%20white%20marble%20surface%20with%20soft%20natural%20lighting%20minimalist%20product%20photography%20health%20supplement%20luxury%20gift&width=400&height=400&seq=12&orientation=squarish",
    badge: "선물추천",
    description: "소중한 분께 건강을 선물하세요. 고급스러운 패키지로 구성된 약손콩 환 선물세트입니다.",
    stock: 30,
  },
];

export const testimonials = [
  {
    id: 1,
    name: "김미영",
    product: "스피루리나 파우더",
    avatar: "M",
    text: "매일 아침 스무디에 넣어 먹고 있어요. 3개월째 꾸준히 먹고 있는데 확실히 피로감이 줄었고 피부도 좋아졌어요. 가족 모두 함께 먹고 있습니다!",
    rating: 5,
  },
  {
    id: 2,
    name: "박준호",
    product: "약손콩 환",
    avatar: "J",
    text: "부모님 선물로 구매했는데 정말 좋아하세요. 소화도 잘 되고 맛도 고소해서 매일 챙겨 드신다고 하십니다. 재구매 예정이에요.",
    rating: 5,
  },
  {
    id: 3,
    name: "이수진",
    product: "스피루리나 정제",
    avatar: "S",
    text: "직장 생활하면서 건강 챙기기 어려웠는데, 간편하게 먹을 수 있어서 너무 좋아요. 면역력이 좋아진 느낌이에요. 강력 추천합니다!",
    rating: 5,
  },
  {
    id: 4,
    name: "정하늘",
    product: "약손콩 분말",
    avatar: "H",
    text: "두유 만들어 먹으니까 정말 고소하고 맛있어요. 아이들도 잘 먹어서 온 가족 건강식으로 딱이에요. 품질이 확실히 다릅니다.",
    rating: 5,
  },
  {
    id: 5,
    name: "최영수",
    product: "스피루리나 파우더",
    avatar: "Y",
    text: "운동 후 단백질 보충용으로 먹고 있습니다. 천연 단백질이라 부담 없고, 회복도 빨라진 것 같아요. 색깔은 진하지만 맛은 부드럽습니다.",
    rating: 4,
  },
  {
    id: 6,
    name: "한소희",
    product: "약손콩 환",
    avatar: "S",
    text: "갱년기 건강 관리를 위해 구매했어요. 꾸준히 먹으니 확실히 컨디션이 좋아졌어요. 포장도 깔끔하고 배송도 빨라서 만족합니다.",
    rating: 5,
  },
];

export const benefits = [
  {
    icon: "ri-leaf-line",
    title: "100% 유기농 인증",
    description: "국내 유기농 인증을 받은 안전한 원료만을 사용합니다.",
  },
  {
    icon: "ri-shield-check-line",
    title: "HACCP 인증 시설",
    description: "위생적인 HACCP 인증 시설에서 엄격한 품질 관리를 거칩니다.",
  },
  {
    icon: "ri-truck-line",
    title: "신선 당일 포장",
    description: "주문 즉시 당일 포장하여 가장 신선한 상태로 배송합니다.",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "영양 성분 검증",
    description: "공인 기관의 영양 성분 분석을 통해 품질을 보증합니다.",
  },
];
